export function throttle(callback, window) {
    let inProgress = false;
    return (...args) => {
        if (inProgress) {
            return;
        }
        inProgress = true;
        callback(...args);
        setTimeout(() => inProgress = false, window);
    };
}
const BASE62_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
export function randomBase62() {
    let random = "";
    for (let i = 0; i < 8; i += 1) {
        const i = randomNum(0, BASE62_CHARS.length - 1);
        random += BASE62_CHARS[i];
    }
    return random;
}
export function randomNum(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
